import { LogIn, LogOut } from 'lucide-react';

import { cn } from '@/lib/utils';
import unifyLogo from '@/assets/unify-logo.png';

/**
 * Full-screen centred onboarding shell with Unify's soft gradient + corner
 * glow background. Mirrors the canonical visual at
 * `fresh-dashboard/src/components/lifecycle/PreTrialScreen.tsx` — a centred
 * column on top of `bg-gradient-soft` with two `bg-gradient-unify` blobs in
 * opposite corners.
 *
 * Top bar carries the Unify wordmark and a small sign-in/out affordance.
 * The previous two-column sidebar layout was retired in favour of this
 * centred treatment so the onboarding visually matches the Lovable design.
 */
export function OnboardingShell({ children, isSignedIn, onSignOut, onSignIn, className }) {
	return (
		<div className={cn('relative min-h-screen w-full overflow-hidden bg-background', className)}>
			<div className="pointer-events-none absolute inset-0 bg-gradient-soft opacity-60" />
			<div className="pointer-events-none absolute -left-20 -top-20 h-72 w-72 rounded-full bg-gradient-unify opacity-20 blur-3xl" />
			<div className="pointer-events-none absolute -bottom-20 -right-20 h-80 w-80 rounded-full bg-gradient-unify opacity-20 blur-3xl" />

			<div className="relative">
				<header className="mx-auto flex max-w-[1100px] items-center justify-between px-6 py-6 md:px-10">
					<img src={unifyLogo} alt="Unify by NearSt" className="h-9 w-auto" />
					{isSignedIn ? (
						<button
							type="button"
							onClick={onSignOut}
							className="inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
						>
							<LogOut className="h-4 w-4" />
							Sign out
						</button>
					) : (
						<button
							type="button"
							onClick={onSignIn}
							className="inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
						>
							<LogIn className="h-4 w-4" />
							Sign in
						</button>
					)}
				</header>

				<main className="mx-auto w-full max-w-[720px] px-6 pb-16 pt-2 md:px-8">{children}</main>
			</div>
		</div>
	);
}
